// extracted by mini-css-extract-plugin
module.exports = {"error-template":"Page404_error-template__1CUor","error-actions":"Page404_error-actions__2MeGx","btn":"Page404_btn__AmJ2H"};